import { Component, HostListener, EventEmitter, Output, TemplateRef, ElementRef, ViewChild, Input, OnInit } from '@angular/core';
import { IconService } from '../../editor/icons/icon.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IconsComponent } from '../../editor/additional/icons/icons.component';
import { iconSidebar } from '../../sidebar/iconSidebar';

@Component({
  selector: 'app-sidebar-new-comp',
  standalone: true,
  imports: [IconsComponent],
  templateUrl: './sidebar-new-comp.component.html',
  styleUrl: './sidebar-new-comp.component.css'
})
export class SidebarNewCompComponent {
    safeHtmlContent: string;
    images: { [key: string]: SafeHtml } = {};
    @Input() name: string = '';
    sanitizedIcon: any;
   constructor(
      private IconService: IconService

    ) {

    }
      ngOnInit() {

        //  sidebae Icons
        const rawIcon = iconSidebar[this.name] || '';
        this.sanitizedIcon = this.IconService.sanitize(rawIcon);
      }

}
